module.exports = "/images/WooCommerce.png?0f3e71ce6b7ddc6c0ca7dbdd6ed7282a";